
export const getLineItemFeeCode = (lineItem) => {
    return `line-item/${lineItem.code.split('/').pop()}`;
}